/** Shared Neo surface tokens (immersive drill-downs). */

export function neoUi(isDark) {
  return isDark
    ? {
        page: 'bg-[#050505] text-white',
        headerBar: 'border-white/10 bg-black/30 backdrop-blur-md',
        headerBtn: 'bg-white/[0.04] border-white/[0.08] text-white/70 hover:bg-white/10',
        title: 'text-white',
        section: 'border-[rgba(255,255,255,0.06)] bg-[#111111]',
        sectionTitle: 'text-white/40',
        card: 'border-[rgba(255,255,255,0.06)] bg-[#111111]',
        listRow: 'border-[rgba(255,255,255,0.06)] bg-[#111111] hover:bg-white/[0.04]',
        inputWrap: 'border-[rgba(255,255,255,0.1)] bg-[rgba(255,255,255,0.04)]',
        input: 'text-white placeholder:text-white/30',
        muted: 'text-white/60',
        borderSubtle: 'border-b border-white/[0.04]',
        footerBar: 'border-white/10',
      }
    : {
        page: 'bg-[#f2f2f7] text-[#1a1a1a]',
        headerBar: 'border-black/10 bg-white/80 backdrop-blur-md',
        headerBtn: 'bg-black/[0.04] border-black/10 text-black/60 hover:bg-black/[0.08]',
        title: 'text-[#1a1a1a]',
        section: 'border-black/10 bg-white',
        sectionTitle: 'text-black/45',
        card: 'border-black/10 bg-white shadow-sm',
        listRow: 'border-black/10 bg-white hover:bg-black/[0.03]',
        inputWrap: 'border-black/10 bg-white',
        input: 'text-[#1a1a1a] placeholder:text-black/35',
        muted: 'text-black/55',
        borderSubtle: 'border-b border-black/[0.08]',
        footerBar: 'border-black/10',
      };
}
